import React from "react";
import styled from "styled-components";
import TableCell from "@mui/material/TableCell";

const ActionButtonStyle = styled.button`
  margin: 0 !important;
  padding: 0 !important;
`;

const ActionCellWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  i {
    color: var(--icon-primary) !important;
    font-size: 18px;
    margin: 0 2px;
  }
`;

function ActionButton({ label, icon, onClick, row, disabled }) {
  const handleClick = () => {
    onClick(row);
  };
  const iconDisplay = typeof icon === "function" ? icon(row) : icon;
  const isDisabled = typeof disabled === "function" ? disabled(row) === true : !!disabled;
  const disabledClass = isDisabled === true ? "disabled" : "";
 
  return (
    <ActionButtonStyle
      type="button"
      title={label}
      onClick={handleClick}
      className={`btn btn-link ${disabledClass}`}
      disabled={isDisabled}
    >
      <i className="material-icons actions-icon-color">{iconDisplay}</i>
    </ActionButtonStyle>
  );
}

function ActionCell({ actions, row }) {
  if (!actions) {
    return null;
  }
  return (
    <TableCell align="center">
      <ActionCellWrapper>
        {actions.map((action, index) => {
          const { label, icon, onClick, hide, disabled } = action;
          if (hide && hide(row)) {
            return null;
          }

          return (
            <ActionButton
              {...action}
              row={row}
              key={`action${index}-${action?.label}`}
            />
          );
        })}
      </ActionCellWrapper>
    </TableCell>
  );
}

export default ActionCell;